import { produce } from 'immer'
import {
  GET_USER_CONNECTIONS_FAILURE,
  GET_USER_CONNECTIONS_INIT,
  GET_USER_CONNECTIONS_SUCCESS,
  GetUserConnectionsActions,
} from 'src/app/PeopleContacts/redux/peopleContacts.actions'
import {
  GET_PERSON_SUCCESS_ACTION,
  GetPersonActions,
} from 'src/app/PeopleDetailFlyout/redux/peopleDetailFlyout.actions'
import { GET_ME_SUCCESS, GetMeActions } from 'src/redux/actions/auth.actions'
import { ErrorDetailMap, parseBackendErrors } from 'src/utils/error.utils'

export interface PeopleContactsState {
  ids: string[]
  loading: boolean
  complete: boolean
  totalItems?: number
  removing: boolean
  removeFailureTopLevelError?: string
  postingUserInvites: boolean
  postInvitesTopLevelError?: string
  postInvitesErrorDetailMap?: ErrorDetailMap<string>
  getUserConnectionsTopLevelError?: string
  getUserConnectionsErrorDetailMap?: ErrorDetailMap<string>
  page?: number
  numberOfPages?: number
}

export const initialState: PeopleContactsState = {
  ids: [],
  loading: false,
  complete: false,
  removing: false,
  postingUserInvites: false,
}

export type Actions =
  | GetUserConnectionsActions
  | GetPersonActions
  | GetMeActions

const CorePeopleContactsReducer = (
  state = initialState,
  action: Actions,
): PeopleContactsState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case GET_USER_CONNECTIONS_INIT: {
        draft.loading = true
        return draft
      }

      case GET_PERSON_SUCCESS_ACTION: {
        draft.ids = Array.from(
          new Set([
            ...draft.ids,
            ...action.payload.map((userConnection) => userConnection.userTo.id),
          ]),
        )

        draft.loading = false
        draft.complete = true
        return draft
      }

      case GET_ME_SUCCESS: {
        draft.ids = [action.payload.id, ...draft.ids]
        return draft
      }

      case GET_USER_CONNECTIONS_SUCCESS: {
        draft.ids =
          action.payload.pagination.page === 0
            ? action.payload.userConnections.map(
                (userConnection) => userConnection.userTo.id,
              )
            : [
                ...draft.ids,
                ...action.payload.userConnections.map(
                  (userConnection) => userConnection.userTo.id,
                ),
              ]
        draft.loading = false
        draft.complete =
          action.payload.pagination.page >=
          action.payload.pagination.numberOfPages - 1
        draft.page = action.payload.pagination.page
        draft.numberOfPages = action.payload.pagination.numberOfPages
        draft.totalItems = action.payload.pagination.totalItems
        return draft
      }

      case GET_USER_CONNECTIONS_FAILURE: {
        const errors = parseBackendErrors(action.payload)

        draft.loading = false
        draft.complete = true
        draft.getUserConnectionsTopLevelError = errors.topLevelError
        draft.getUserConnectionsErrorDetailMap = errors.errorDetailMap
        return draft
      }
    }
  })
}

const PeopleContactsReducer = CorePeopleContactsReducer

export default PeopleContactsReducer
